import { ModuleWithProviders, NgModule } from '@angular/core';

import { KeyingHierarchyComponent } from './keying-hierarchy.component';
import { HierarchyComponent } from './components/hierarchy/hierarchy.component';
import { MenuItemComponent } from './components/hierarchy/menu-item/menu-item.component';
import { MasterKeyTreeComponent } from './components/hierarchy/master-key-tree/master-key-tree.component';
import { KeyingMaterialModule } from './keying.material.module';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HierarchyConfig,
  IHierarchyConfig,
} from './configuration/keying.hierarchy.environment.config';
import { KeyingHierarchyService } from './keying-hierarchy.service';
import { KeyComponent } from './components/key/key.component';
import { KeyActionsComponent } from './components/key-actions/key-actions.component';
import { DealerMasterKeyTreeComponent } from './components/hierarchy/dealer-key-tree/dealer-masterkey-tree.component';

@NgModule({ declarations: [
        KeyingHierarchyComponent,
        KeyComponent,
        HierarchyComponent,
        MenuItemComponent,
        MasterKeyTreeComponent,
        KeyActionsComponent,
        DealerMasterKeyTreeComponent
    ],
    exports: [
        KeyingHierarchyComponent,
        HierarchyComponent,
        MenuItemComponent,
        KeyComponent,
    ], imports: [KeyingMaterialModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class KeyingHierarchyModule {
  static forRoot(
    config: IHierarchyConfig
  ): ModuleWithProviders<KeyingHierarchyModule> {
    return {
      ngModule: KeyingHierarchyModule,
      providers: [
        KeyingHierarchyService,
        {
          provide: HierarchyConfig,
          useValue: HierarchyConfig.createConfig(config),
        },
      ],
    };
  }
}
